//NOTE: BE still returns these guest reservation source types, but clients may no longer self-serve
//add them from an integration picker - the Connect Listings wizard (which requires a Listing ID) is
//the only supported way in. Existing integrations are unaffected.
const BLOCKED_INTEGRATION_NAMES = ['airbnb', 'vrbo', 'booking.com'];

export function filterBlockedIntegrations<T extends { name?: string }>(sourceTypes: T[]): T[] {
  return sourceTypes.filter((sourceType) => !BLOCKED_INTEGRATION_NAMES.includes(sourceType.name?.toLowerCase()));
}
